<template>
  <FullCalendar :options="calendarOptions" />
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

import moment from "moment";

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        selectable: true,
        timeZone: "UTC",
        selectOverlap: false,
        select: this.handleSelect,
        eventClick: this.handleClick
      },

      dataModal: ""
    };
  },

  methods: {
    formatDate(date) {
      let newDate = moment.utc(date).format("YYYY-MM-DD HH:mm");
      return (this.dataModal = newDate);
    },

    handleSelect(arg) {
      console.log(arg);
      this.formatDate(arg.startStr);
      this.$emit("dateTime", this.dataModal);
    },

    handleClick(arg) {
      console.log(arg);
    }
  }
};
</script>

<style>
.fc-title {
  color: #fff;
}

.fc-sat {
  background-color: rgb(235, 255, 221);
}

.fc-sun {
  background-color: rgb(235, 255, 221);
}
</style>
